import {
  GbApiRequestService,
  withSchemaValidation,
} from "@/services/ApiRequestService";

import { SignInFormSchema, SignInResponseDto } from "../models";

export abstract class SignInFormApi {
  static async signIn(query: SignInFormSchema) {
    const response = GbApiRequestService.post(
      "rlogin",
      {
        doremember: true,
        requestType: "login",
        ...query,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      },
    );

    return withSchemaValidation(response, SignInResponseDto);
  }
}
